import { ConfigProvider } from 'antd';
import { antComponentsTheme } from './antTheme/antComponentsTheme';

import { antGlobalTheme } from 'antTheme/antGlobalTheme';

import './global-styles.scss';
import { router } from 'routing';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'constants/query-client';
import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider
      theme={{
        components: antComponentsTheme,
        token: antGlobalTheme,
      }}
    >
      <RouterProvider
        router={router}
        fallbackElement={<FullScreenLoaderComponent spinning />}
      />
    </ConfigProvider>
  </QueryClientProvider>
);

export default App;
